export type IconSize = '16' | '24' | '32';

export type IconExtendedSize = '6' | '8' | '12' | '16' | '24' | '32';

export type ShieldIconSize = '8' | '16' | '24' | '32';

export type GatacaLogoIconSize = '12' | '16' | '24' | '32' | '64' | '71';
export type GatacaLogoHorSize = '8' | '24';

export type LoaderPrototipeIconSize = '24' | '40';

export type IconStyle = 'outline' | 'filled';

export type BellIconStyle = 'outline' | 'filled' | 'active';

export const iconStrokeWidthBySize = {
  '6': '0.5',
  '8': '0.666667',
  '12': '1',
  '16': '1.33333',
  '24': '2',
  '32': '2.66667',
};
